import { apiClient } from './client';

export interface FiscalYearDto {
  fiscalYearId: number;
  fiscalYearCode: string;
  fiscalYearDesc?: string;
  isActive: boolean;
  createdBy: number;
  createdOn: string;
  modifiedBy?: number;
  modifiedOn?: string;
}

export const fiscalYearsApi = {
  list: async () => await apiClient.get<FiscalYearDto[]>('/api/fiscal-years'),
  getById: async (id: number) => await apiClient.get<FiscalYearDto>(`/api/fiscal-years/${id}`),
};
